<template>
    <header id="top_info" class="header" role="navigation">
        <div class="header" id="top_info_bg"></div>
        <div class="container">
            <!--------------------------header logo--------------------------->
            <!--<div class="header-logo">
                <h1 class="header-brand">
                    <a alt="EKIOSK">
                        <img src="~/../../assets/images/ekioska/white-logo.png" class="fulllogo qw" alt="EKIOSK">
                        <img src="~/../../assets/images/ekioska/mini-logo.png" class="minilogo" alt="EKIOSK">
                    </a>
                </h1>
            </div>-->
            <!------------------------end header logo---------------------------></div>
        <!-- /.container-fluid -->
    </header>
</template>
<script>
    export default {
    }
</script>